import React from 'react';
import Image from 'next/image';

const PartnershipBadges = () => {
  return (
    <section className="py-12 bg-card border-y border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-sm font-headline font-semibold text-muted-foreground uppercase tracking-wide mb-2">
            Trusted Technology Partners
          </p>
          <h3 className="text-2xl md:text-3xl font-headline font-bold text-foreground">
            Certified Expertise You Can Trust
          </h3>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          <div className="group relative">
            <Image
              src="/assets/images/Microsoft-Partner-1767340959771.png"
              alt="Microsoft Partner certification badge"
              width={160}
              height={64}
              unoptimized
              className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-all duration-base cursor-pointer group-hover:scale-105" />

            <div className="absolute inset-0 rounded-md shadow-partnership opacity-0 group-hover:opacity-100 transition-opacity duration-base pointer-events-none" />
          </div>

          <div className="group relative">
            <Image
              src="/assets/images/Screenshot_2026-01-02_at_12.41.30_PM-1767340820772.png"
              alt="AWS Partner Network certification badge"
              width={120}
              height={64}
              unoptimized
              className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-all duration-base cursor-pointer group-hover:scale-105" />

            <div className="absolute inset-0 rounded-md shadow-partnership opacity-0 group-hover:opacity-100 transition-opacity duration-base pointer-events-none" />
          </div>

          <div className="flex items-center space-x-3 px-6 py-3 bg-brand-light rounded-lg">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center">
              <span className="text-white font-headline font-bold text-lg">V</span>
            </div>
            <div>
              <p className="text-xs text-brand-blue font-headline font-semibold uppercase tracking-wide">
                Certified
              </p>
              <p className="text-sm text-brand-blue font-headline font-bold">
                Azure Solutions
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-3 px-6 py-3 bg-brand-light rounded-lg">
            <div className="w-10 h-10 bg-gradient-to-br from-secondary to-accent rounded-full flex items-center justify-center">
              <span className="text-white font-headline font-bold text-lg">V</span>
            </div>
            <div>
              <p className="text-xs text-brand-blue font-headline font-semibold uppercase tracking-wide">
                Certified
              </p>
              <p className="text-sm text-brand-blue font-headline font-bold">
                AWS Solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default PartnershipBadges;